import styled from "@emotion/styled";
import { basicStyle, containerStyle, themed } from "./common";

export default themed(styled.div`
  ${basicStyle};
  ${containerStyle};
`);
